import { useContext } from "react";

import {
  CustomStorageContext,
  CustomStorageContextData,
} from "../contexts/CustomStorage";

export function useCustomStorage(): CustomStorageContextData {
  const context = useContext(CustomStorageContext);

  if (!context) {
    throw new Error(
      "useCustomStorage must be used within an CustomStorageProvider"
    );
  }

  return context;
}
